import React from 'react';

interface IconProps { size?: number; color?: string; }

/** 하작물 — 새싹/잎 SVG */
export const SummerIcon: React.FC<IconProps> = ({ size = 15, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    {/* 줄기 */}
    <line x1="8" y1="15" x2="8" y2="8.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    {/* 잎 — 두 잎이 아치형으로 만나는 새싹 */}
    <path
      d="M8 8.5 C7 6 4 6.5 4 3.5 C4 3.5 5.5 1.5 8 5.5 C10.5 1.5 12 3.5 12 3.5 C12 6.5 9 6 8 8.5Z"
      fill={color}
    />
    {/* 작은 뿌리 곡선 */}
    <path d="M8 15 C8 15 6.5 14 6 13" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.5" />
  </svg>
);

/** 동작물 — 눈꽃(결정) SVG */
export const WinterIcon: React.FC<IconProps> = ({ size = 15, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    {/* 6방향 축 (수직 + 수평 + 대각) */}
    <line x1="8" y1="1.5" x2="8" y2="14.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="1.5" y1="8" x2="14.5" y2="8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="3.2" y1="3.2" x2="12.8" y2="12.8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="12.8" y1="3.2" x2="3.2" y2="12.8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    {/* 끝점 원 (4방향) */}
    <circle cx="8" cy="2" r="1.1" fill={color} />
    <circle cx="8" cy="14" r="1.1" fill={color} />
    <circle cx="2" cy="8" r="1.1" fill={color} />
    <circle cx="14" cy="8" r="1.1" fill={color} />
    {/* 끝점 원 (대각) */}
    <circle cx="4" cy="4" r="1" fill={color} />
    <circle cx="12" cy="12" r="1" fill={color} />
    <circle cx="12" cy="4" r="1" fill={color} />
    <circle cx="4" cy="12" r="1" fill={color} />
    {/* 중앙 */}
    <circle cx="8" cy="8" r="2" fill={color} />
  </svg>
);

interface SeasonBadgeProps {
  value: string;  // summer_winter 필드값
  size?: 'sm' | 'md';
}

/** 테이블 셀용 작기 뱃지 — 하작물(초록) / 동작물(파랑) */
export const SeasonBadge: React.FC<SeasonBadgeProps> = ({ value, size = 'sm' }) => {
  const isDong = ['W', '동', 'w'].includes((value || '').trim());
  const isSummer = ['S', 'E', 's', 'e', '하'].includes((value || '').trim());
  if (!isDong && !isSummer) return <span style={{ color: '#e2e8f0', fontSize: 12 }}>—</span>;

  const pad = size === 'sm' ? '2px 7px' : '3px 10px';
  const fs = size === 'sm' ? 10 : 11.5;
  const emojiSize = size === 'sm' ? 11 : 13;

  return isDong ? (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: pad, borderRadius: 12,
      background: 'linear-gradient(135deg,#dbeafe,#eff6ff)',
      border: '1px solid #93c5fd',
      fontSize: fs, fontWeight: 700, color: '#1d4ed8',
      whiteSpace: 'nowrap',
    }}>
      <span style={{ fontSize: emojiSize, lineHeight: 1 }}>🧊</span>
      동
    </span>
  ) : (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: pad, borderRadius: 12,
      background: 'linear-gradient(135deg,#dcfce7,#f0fdf4)',
      border: '1px solid #86efac',
      fontSize: fs, fontWeight: 700, color: '#166534',
      whiteSpace: 'nowrap',
    }}>
      <span style={{ fontSize: emojiSize, lineHeight: 1 }}>☀️</span>
      하
    </span>
  );
};
